"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorOptimizeQueryOperationLeftjoinExpressionPushdown = void 0;
const bus_optimize_query_operation_1 = require("@comunica/bus-optimize-query-operation");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_query_operation_1 = require("@comunica/utils-query-operation");
const sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A comunica LeftJoin Expression Pushdown Optimize Query Operation Actor.
 */
class ActorOptimizeQueryOperationLeftjoinExpressionPushdown extends bus_optimize_query_operation_1.ActorOptimizeQueryOperation {
    constructor(args) {
        super(args);
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const algebraFactory = new sparqlalgebrajs_1.Factory(dataFactory);
        let operation = action.operation;
        // eslint-disable-next-line ts/no-this-alias
        const self = this;
        operation = sparqlalgebrajs_1.Util.mapOperation(operation, {
            leftjoin(op, factory) {
                // Try to push the expression to either the left or right if it exclusively overlaps with just one of them.
                if (op.expression) {
                    const variablesExpression = (0, utils_query_operation_1.getExpressionVariables)(op.expression);
                    const variablesLeft = sparqlalgebrajs_1.Util.inScopeVariables(op.input[0]);
                    const variablesRight = sparqlalgebrajs_1.Util.inScopeVariables(op.input[1]);
                    const intersectLeft = self.variablesIntersect(variablesExpression, variablesLeft);
                    const intersectRight = self.variablesIntersect(variablesExpression, variablesRight);
                    if (intersectLeft && !intersectRight) {
                        self.logDebug(action.context, `Pushed down optional expression to left-hand operator`);
                        return {
                            recurse: true,
                            result: factory.createLeftJoin(factory.createFilter(op.input[0], op.expression), op.input[1]),
                        };
                    }
                    if (!intersectLeft && intersectRight) {
                        self.logDebug(action.context, `Pushed down optional expression to right-hand operator`);
                        return {
                            recurse: true,
                            result: factory.createLeftJoin(op.input[0], factory.createFilter(op.input[1], op.expression)),
                        };
                    }
                }
                return {
                    recurse: true,
                    result: op,
                };
            },
        }, algebraFactory);
        return { operation, context: action.context };
    }
    /**
     * Check if there is an overlap between the two given lists of variables.
     * @param varsA A list of variables.
     * @param varsB A list of variables.
     */
    variablesIntersect(varsA, varsB) {
        return varsA.some(varA => varsB.some(varB => varA.equals(varB)));
    }
}
exports.ActorOptimizeQueryOperationLeftjoinExpressionPushdown = ActorOptimizeQueryOperationLeftjoinExpressionPushdown;
//# sourceMappingURL=ActorOptimizeQueryOperationLeftjoinExpressionPushdown.js.map